interface UptimeWingLogoProps {
  className?: string;
}

export function UptimeWingLogo({ className = "" }: UptimeWingLogoProps) {
  return (
    <img
      src="/logo-v3.png"
      alt="UptimeWing Sentinel"
      className={`${className} object-contain`}
    />
  );
}
